import _ from 'lodash'
import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Autocomplete as AutocompleteMUI } from '@mui/material'
import {
  setEnableSectionField,
  setEnableSiteField,
  setEnableAcronymField,
} from '../../redux/slices/Tree/treeFeatures'
import { getSitesDataByName } from '../../services'
import Textfield from '../FormsUI/Textfield'

const MSJ_ERROR = { error: true, helperText: 'Obligatorio' }

const InputGroup2 = ({ name, options, editable, ...rest }) => {
  const dispatch = useDispatch()
  const optionsListInitial = _.map(options, (label, id) => ({ id, label }))

  const idInitValue = _.findIndex(optionsListInitial, 'selectedInitial')
  const [optionsList, setOptionsList] = React.useState(optionsListInitial)
  const [filterList1, setSelectedList] = React.useState({
    id: idInitValue,
    label: rest.initvalue ?? '',
  })

  const siteSelected = useSelector(
    state => state.treeFeatures.enableSaveButton.siteField?.selected
  )

  const fields = useSelector(state => state.treeFeatures.enableSaveButton)
  const { siteField, siteAcronym, sectionField } = fields
  const infoError = {
    site_: siteField,
    section_: sectionField,
    siteAcronym_: siteAcronym,
  }

  const handleSelection = (event, newList) => setSelectedList(newList)

  const handleOnBlur = () => {
    if (name === 'site_')
      if (!siteField.error && !Boolean(siteField?.selected?.length))
        dispatch(setEnableSiteField(MSJ_ERROR))
    if (name === 'section_')
      if (!sectionField.error && !Boolean(sectionField?.selected?.length))
        dispatch(setEnableSectionField(MSJ_ERROR))
    if (name === 'siteAcronym_')
      if (!siteAcronym.error && !Boolean(siteAcronym?.selected?.length))
        dispatch(setEnableAcronymField(MSJ_ERROR))
  }

  const handleOnInputChange = (e, value) => {
    let newObject = !Boolean(value) ? MSJ_ERROR : { error: false, selected: value }
    if (name === 'site_') dispatch(setEnableSiteField(newObject))
    if (name === 'section_') dispatch(setEnableSectionField(newObject))
    if (name === 'siteAcronym_') dispatch(setEnableAcronymField(newObject))
  }

  const othersProps = {
    name,
    value: filterList1?.id ?? '',
    label: rest.label,
    variant: 'filled',
    size: 'small',
    error: infoError?.[name]?.error,
    helperText: infoError?.[name]?.helperText,
  }

  React.useEffect(() => {
    return () => {
      const MSJ_DEFAULT = { error: false, selected: null }
      const obj = {
        site_: setEnableSiteField(MSJ_DEFAULT),
        section_: setEnableSectionField(MSJ_DEFAULT),
        siteAcronym_: setEnableAcronymField(MSJ_DEFAULT),
      }
      dispatch(obj[name])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  React.useEffect(() => {
    if (name === 'site_') return
    if (!Boolean(siteSelected)) return
    const fieldName = name === 'section_' ? 'seccion' : 'acronimoSitio'
    getSitesDataByName(siteSelected, fieldName)
      .then(filteredOptions => setOptionsList(filteredOptions))
      .catch(err => console.log('Error :>> ', err))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [siteSelected])

  return (
    <AutocompleteMUI
      freeSolo
      id={`free-solo-${name}`}
      name={name}
      value={filterList1}
      onChange={handleSelection}
      onInputChange={handleOnInputChange}
      options={optionsList}
      onBlur={handleOnBlur}
      readOnly={!editable}
      getOptionLabel={option => option.label}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={params => <Textfield {...params} {...othersProps} />}
    />
  )
}

export default React.memo(InputGroup2)
